<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.55859 8.0501V14.5401L8.04359 14.5351L14.5286 14.5301L14.5336 8.04506L14.5387 1.56006H8.04863H1.55859V8.0501ZM16.2386 2.19006V2.82006H16.7086H17.1786V8.05006V13.2801H16.7083H16.238L16.2433 13.9051L16.2486 14.5301L17.8136 14.5352L19.3786 14.5403V13.9102V13.2801H18.9086H18.4386V8.05006V2.82006H18.9086H19.3786V2.19006V1.56006H17.8086H16.2386V2.19006ZM2.81859 8.05006V13.2801H8.04859H13.2786V8.05006V2.82006H8.04859H2.81859V8.05006ZM1.55859 17.8101V19.3801H2.18859H2.81859V18.9101V18.4401H8.04859H13.2786V18.9101V19.3801H13.9087H14.5388L14.5337 17.8151L14.5286 16.2501L13.9036 16.2448L13.2786 16.2395V16.7098V17.1801H8.04859H2.81859V16.7101V16.2401H2.18859H1.55859V17.8101Z"
      fill="currentColor"
    />
  </svg>
</template>
